import { render, staticRenderFns } from "./proposal-detail-fondocyt.vue?vue&type=template&id=30045631&scoped=true&"
import script from "./proposal-detail-fondocyt.vue?vue&type=script&lang=ts&"
export * from "./proposal-detail-fondocyt.vue?vue&type=script&lang=ts&"
import style0 from "./proposal-detail-fondocyt.vue?vue&type=style&index=0&id=30045631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30045631",
  null
  
)

export default component.exports